function normalizedCategory(value: string) {
  return value
    .toLocaleLowerCase("tr-TR")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replaceAll("ı", "i")
    .replace(/[^a-z0-9]/g, "");
}

const compatibleSupplierCategories: Record<string, string[]> = {
  ambalaj: ["ambalaj"],
  hammadde: ["hammadde"],
  sarfmalzeme: ["sarfmalzeme"],
  bakimveteknikhizmet: ["bakimveservis", "bakimhizmeti", "enerjibakimhizmeti"],
  makineveyedekparca: ["makineveekipman", "yedekparca"],
  lojistik: ["lojistik", "lojistikambalaji"],
  lojistikambalaji: ["lojistik", "lojistikambalaji"],
  kalitevelaboratuvar: ["laboratuvar", "laboratuvarsarfi", "kimyasal"],
  kalite: ["laboratuvar", "laboratuvarsarfi", "kimyasal"],
  laboratuvarsarfi: ["laboratuvar", "laboratuvarsarfi", "kimyasal"],
  kimyasal: ["kimyasal"],
  bakimhizmeti: ["bakimveservis", "bakimhizmeti", "enerjibakimhizmeti"],
  enerjibakimhizmeti: ["bakimveservis", "bakimhizmeti", "enerjibakimhizmeti"],
  yedekparca: ["makineveekipman", "yedekparca"],
  bilgiteknolojileri: ["bilgiteknolojileri"],
  ofisveidari: ["sarfmalzeme", "genel"],
};

export function supplierMatchesRequestCategory(
  requestCategory: string | undefined,
  supplierCategory: string | readonly string[],
) {
  const request = normalizedCategory(requestCategory ?? "");
  if (!request || request === "genel") return true;
  const suppliers = (Array.isArray(supplierCategory) ? supplierCategory : [supplierCategory])
    .map((category) => normalizedCategory(category));
  return suppliers.some((supplier) =>
    (compatibleSupplierCategories[request] ?? [request]).includes(supplier),
  );
}
